var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("webHeader", { attrs: { "is-fixed-header": _vm.isFixedGameTab } }),
          _c(
            "div",
            { ref: "mobileHeader", attrs: { id: "mobileHeader" } },
            [_c("mobileHeader")],
            1
          ),
          _c("Banner"),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "div",
                {
                  ref: "marqueeBlock",
                  staticClass: "marquee-block",
                  attrs: { id: "marqueeBlock" },
                },
                [_c("MarqueeComponent")],
                1
              ),
              _c("GameTabComponent", {
                attrs: {
                  "is-fixed-game-tab": _vm.isFixedGameTab,
                  "current-game-tab": _vm.currentGameTab,
                  "set-tab": _vm.setTab,
                  "tab-game-list": _vm.tabGameList,
                  "is-device": _vm.isDevice,
                  loading: _vm.gameLoading,
                },
                on: {
                  "update:isFixedGameTab": function ($event) {
                    _vm.isFixedGameTab = $event
                  },
                  "update:is-fixed-game-tab": function ($event) {
                    _vm.isFixedGameTab = $event
                  },
                },
              }),
              _c("GameListComponent", {
                attrs: {
                  "is-fixed-game-tab": _vm.isFixedGameTab,
                  "result-game-list": _vm.resultGameList,
                  "refresh-status": _vm.refresh,
                  loading: _vm.gameLoading,
                },
                on: {
                  "update:isFixedGameTab": function ($event) {
                    _vm.isFixedGameTab = $event
                  },
                  "update:is-fixed-game-tab": function ($event) {
                    _vm.isFixedGameTab = $event
                  },
                  windowPage: _vm.getWindowPage,
                },
              }),
            ],
            1
          ),
          _c("ModalComponent"),
          _c("Footer"),
          _c("notifications", {
            attrs: {
              position: "top center",
              duration: 3000,
              classes: "custom-template",
            },
          }),
          _c("goTop"),
          _c("LoadingAnimate", { attrs: { "is-loading": _vm.isLoading } }),
          _c("BetDetailIframe"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }